module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__chileClassic.505292e6.svg";